import workspaceQuery from 'graphql/queries/nominal/NominalCommonAccountSetWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalCommonAccountSetListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalCommonAccountSetQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalCommonAccountSetDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalCommonAccountSetMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalCommonAccountSetFragment.graphql';

const NominalCommonAccountSet = {
  type: 'NominalCommonAccountSet',
  title: 'Common Account Sets',
  formTitle: 'Common Account Set',
  formUrl: '/Nominal/CommonAccountSet/Details/',
  workspaceUrl: '/Nominal/CommonAccountSet/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'nominalBusinessCategory.description',
  },
  fragment,
  screenReference: 'NOMINAL_COMMON_ACCOUNT_SET',
};

export default NominalCommonAccountSet;
